import { Tabs as TabsPrimitive } from 'radix-ui'
import type { ComponentPropsWithoutRef, ReactNode } from 'react'
import { cn } from '@/utils/cn'

export const Tabs = TabsPrimitive.Root

export function TabsList({ className, ...props }: ComponentPropsWithoutRef<typeof TabsPrimitive.List>) {
  return (
    <TabsPrimitive.List
      className={cn('-mb-px flex scrollbar-thin gap-1 overflow-x-auto border-b border-line', className)}
      {...props}
    />
  )
}

interface TabsTriggerProps extends ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger> {
  icon?: ReactNode
  count?: number
}

export function TabsTrigger({ className, icon, count, children, ...props }: TabsTriggerProps) {
  return (
    <TabsPrimitive.Trigger
      className={cn(
        'group inline-flex shrink-0 items-center gap-2 border-b-2 border-transparent px-3 pt-2 pb-2.5 text-sm font-medium text-muted transition-colors hover:text-ink data-[state=active]:border-brand-600 data-[state=active]:text-brand-700 [&_svg]:size-4',
        className,
      )}
      {...props}
    >
      {icon}
      {children}
      {count !== undefined ? (
        <span className="rounded-full bg-surface-sunken px-1.5 py-px text-2xs text-muted tabular group-data-[state=active]:bg-brand-50 group-data-[state=active]:text-brand-700">
          {count}
        </span>
      ) : null}
    </TabsPrimitive.Trigger>
  )
}

export function TabsContent({ className, ...props }: ComponentPropsWithoutRef<typeof TabsPrimitive.Content>) {
  return (
    <TabsPrimitive.Content
      className={cn('animate-fade-in pt-5 focus-visible:outline-none', className)}
      {...props}
    />
  )
}
